// PageVariablesPropostas.js

export const pageVariables = {
    headers: [
        'SEGURADO', 'PLANO', 'EMPRESA', 'CONSULTOR', 'PERIODICIDADE', 'FORMA PAGAMENTO', 'CUSTEIO',
        'PRÊMIO LÍQUIDO', 'IOF', 'TOTAL', 'CAPITAL', 'DOCUMENTO'
    ],
    headerInfo: {
        title: "Propostas",
        description: "Visualize abaixo as propostas cadastradas, com informações resumidas sobre o segurado, plano, empresa estipulante, valores envolvidos e o link do documento. A listagem serve como ponto de partida para o acompanhamento e análise de cada proposta de forma rápida e eficiente."
    },
    inputs: [],
    page: process.env.VUE_APP_API_URL+"propostas",
    searchPage:process.env.VUE_APP_API_URL+"apolices",
    singularAccessPage: process.env.VUE_APP_API_URL+"proposta",
};
